/* The Vapory 2026 — theme JS. No dependencies. */
(() => {
  const T = window.theme || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', cartUpdate: '/cart/update', predictiveSearch: '/search/suggest' }, cartType: 'page', strings: {} };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
  const debounce = (fn, ms = 250) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])';

  /* ---------- toast ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $('[data-toast]');
    if (!el || !msg) return;
    el.textContent = msg; el.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => { el.hidden = true; }, 3000);
  }

  /* ---------- focus trap / overlays (drawers, modal, search) ---------- */
  const openStack = [];
  function trap(e) {
    const top = openStack[openStack.length - 1];
    if (!top) return;
    if (e.key === 'Escape') { e.preventDefault(); top.close(); return; }
    if (e.key !== 'Tab') return;
    const f = $$(FOCUSABLE, top.el).filter((n) => n.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  document.addEventListener('keydown', trap);

  function openOverlay(el, opener, { lock = true, onClose } = {}) {
    if (!el || openStack.some((o) => o.el === el)) return;
    el.hidden = false;
    if (opener) opener.setAttribute('aria-expanded', 'true');
    const entry = {
      el, opener,
      close() {
        el.hidden = true;
        if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus({ preventScroll: true }); }
        const i = openStack.indexOf(entry); if (i > -1) openStack.splice(i, 1);
        if (!openStack.some((o) => o.lock)) document.body.classList.remove('is-locked');
        if (onClose) onClose();
      },
      lock
    };
    openStack.push(entry);
    if (lock) document.body.classList.add('is-locked');
    const target = $('[autofocus], input[type=search]', el) || $(FOCUSABLE, el);
    if (target) setTimeout(() => target.focus({ preventScroll: true }), 30);
    return entry;
  }
  function closeOverlay(el) { const e = openStack.find((o) => o.el === el); if (e) e.close(); }
  const isOpen = (el) => openStack.some((o) => o.el === el);

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      const el = document.getElementById(opener.dataset.drawerOpen);
      if (el && getComputedStyle(opener).display !== 'none') { e.preventDefault(); openOverlay(el, opener); }
      return;
    }
    const closer = e.target.closest('[data-drawer-close], [data-modal-close]');
    if (closer) { const el = closer.closest('.drawer, .modal'); if (el) { e.preventDefault(); closeOverlay(el); } }
  });

  /* ---------- in-page anchors (e.g. /#stores): close overlays, smooth scroll below sticky bars ---------- */
  function headerOffset() {
    const hw = $('.health-warning'); const sh = $('sticky-header.header-wrapper--sticky');
    return (hw ? hw.offsetHeight : 0) + (sh ? sh.offsetHeight : 0) + 12;
  }
  function scrollToHash(hash, smooth) {
    let t = null;
    try { t = hash && hash.length > 1 ? document.getElementById(decodeURIComponent(hash.slice(1))) : null; } catch (err) { t = null; }
    if (!t) return false;
    const y = t.getBoundingClientRect().top + window.scrollY - headerOffset();
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, y), behavior: smooth && !reduce ? 'smooth' : 'auto' });
    return true;
  }
  document.addEventListener('click', (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest('a[href*="#"]');
    if (!a || a.target === '_blank') return;
    const u = new URL(a.href, location.href);
    if (u.origin !== location.origin || u.pathname !== location.pathname || !u.hash || u.hash === '#') return;
    let t = null; try { t = document.getElementById(decodeURIComponent(u.hash.slice(1))); } catch (err) { return; }
    if (!t) return;
    e.preventDefault();
    openStack.slice().reverse().forEach((o) => { if (o.el.tagName !== 'AGE-GATE') o.close(); });
    if (location.hash !== u.hash) history.pushState(null, '', u.hash);
    requestAnimationFrame(() => scrollToHash(u.hash, true));
  });
  window.addEventListener('load', () => { if (location.hash) setTimeout(() => scrollToHash(location.hash, false), 60); });

  /* ---------- age gate ---------- */
  class AgeGate extends HTMLElement {
    connectedCallback() {
      const html = document.documentElement;
      const days = parseInt(this.dataset.days ?? '30', 10);
      const name = this.dataset.cookie || 'vapory_age_ok';
      const secure = location.protocol === 'https:' ? '; Secure' : '';
      // Session mode: clear any old 30-day cookie so returning visitors are asked again.
      if (name !== 'vapory_age_ok') document.cookie = `vapory_age_ok=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax${secure}`;
      const ok = document.cookie.split('; ').some((c) => c === `${name}=1`);
      if (this.hasAttribute('data-editor')) { this.show(); }
      else if (ok) { html.classList.remove('age-gate-open'); return; }
      else this.show();
      $('[data-age-confirm]', this)?.addEventListener('click', () => {
        const exp = days > 0 ? `; expires=${new Date(Date.now() + days * 864e5).toUTCString()}` : '';
        document.cookie = `${name}=1${exp}; path=/; SameSite=Lax${secure}`;
        this.hide();
      });
      $('[data-age-decline]', this)?.addEventListener('click', () => {
        window.location.href = this.dataset.declineUrl || 'https://www.google.com';
      });
    }
    show() {
      document.documentElement.classList.add('age-gate-open');
      this.hidden = false;
      this.entry = openOverlay(this, null, { lock: true });
      // Esc must not dismiss the gate
      if (this.entry) this.entry.close = () => {};
    }
    hide() {
      document.documentElement.classList.remove('age-gate-open');
      this.hidden = true;
      const i = openStack.indexOf(this.entry); if (i > -1) openStack.splice(i, 1);
      if (!openStack.some((o) => o.lock)) document.body.classList.remove('is-locked');
    }
  }
  customElements.define('age-gate', AgeGate);

  /* ---------- sticky header ---------- */
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      if (!this.classList.contains('header-wrapper--sticky')) return;
      const onScroll = () => this.classList.toggle('is-scrolled', window.scrollY > 10);
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
      // search modal
      const modal = $('#SearchModal', this);
      $$('[data-search-open]', this).forEach((b) => b.addEventListener('click', () => {
        if (isOpen(modal)) closeOverlay(modal); else openOverlay(modal, b, { lock: false });
      }));
      $$('[data-search-close]', this).forEach((b) => b.addEventListener('click', () => closeOverlay(modal)));
      document.addEventListener('click', (e) => { if (isOpen(modal) && !this.contains(e.target)) closeOverlay(modal); });
    }
  }
  customElements.define('sticky-header', StickyHeader);
  // non-sticky header still needs search
  document.addEventListener('DOMContentLoaded', () => {
    const header = $('sticky-header');
    if (header && !header.classList.contains('header-wrapper--sticky')) {
      const modal = $('#SearchModal');
      $$('[data-search-open]').forEach((b) => b.addEventListener('click', () => { if (isOpen(modal)) closeOverlay(modal); else openOverlay(modal, b, { lock: false }); }));
      $$('[data-search-close]').forEach((b) => b.addEventListener('click', () => closeOverlay(modal)));
    }
  });

  /* ---------- desktop menus: hover open, close others, click outside ---------- */
  const hoverable = window.matchMedia('(hover: hover) and (min-width: 990px)');
  document.addEventListener('DOMContentLoaded', () => {
    const menus = $$('details[data-hover-menu]');
    menus.forEach((d) => {
      let t;
      d.addEventListener('mouseenter', () => { if (!hoverable.matches) return; clearTimeout(t); menus.forEach((m) => m !== d && m.removeAttribute('open')); d.setAttribute('open', ''); });
      /* a mouse click on a summary that hover already opened would otherwise toggle it shut (menu looks empty) */
      $('summary', d).addEventListener('click', (e) => { if (hoverable.matches && e.detail > 0 && d.open) e.preventDefault(); });
      d.addEventListener('mouseleave', () => { if (!hoverable.matches) return; t = setTimeout(() => d.removeAttribute('open'), 150); });
      d.addEventListener('toggle', () => { if (d.open) menus.forEach((m) => m !== d && m.removeAttribute('open')); });
      d.addEventListener('keydown', (e) => { if (e.key === 'Escape' && d.open) { d.removeAttribute('open'); $('summary', d).focus(); } });
    });
    document.addEventListener('click', (e) => { menus.forEach((m) => { if (m.open && !m.contains(e.target)) m.removeAttribute('open'); }); });
  });

  /* ---------- priority nav: one row, overflow links move into "More" ---------- */
  const initPriorityNav = () => {
    const list = $('[data-priority-nav]');
    if (!list) return;
    const nav = list.parentElement;
    const more = $('[data-more]', list);
    const items = $$(':scope > [data-nav-index]', list);
    const moreEntries = $$('[data-more-index]', more);
    const byIndex = (i) => moreEntries.find((e) => e.dataset.moreIndex === i);
    const layout = () => {
      items.forEach((li) => { li.hidden = false; });
      moreEntries.forEach((e) => { e.hidden = true; });
      more.hidden = true;
      if (!nav.offsetWidth) { list.classList.add('is-ready'); return; }
      const fits = () => list.scrollWidth <= nav.clientWidth + 1;
      if (!fits()) {
        more.hidden = false;
        for (let i = items.length - 1; i >= 0 && !fits(); i -= 1) {
          items[i].hidden = true;
          const entry = byIndex(items[i].dataset.navIndex);
          if (entry) entry.hidden = false;
        }
      }
      if (!moreEntries.some((e) => !e.hidden)) { more.hidden = true; $('details', more).removeAttribute('open'); }
      const activeHidden = items.some((li) => li.hidden && li.querySelector('.is-active'));
      $('summary', more).classList.toggle('is-active', activeHidden);
      list.classList.add('is-ready');
    };
    let raf;
    const schedule = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(layout); };
    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(nav); else window.addEventListener('resize', schedule);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
    layout();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPriorityNav); else initPriorityNav();

  /* ---------- live-sorted product grids (best selling / newest) via Section Rendering API ---------- */
  const initLiveSort = () => {
    $$('[data-live-sort]').forEach((grid) => {
      const limit = parseInt(grid.dataset.limit, 10) || 8;
      fetch(grid.dataset.liveSort, { credentials: 'same-origin' })
        .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
        .then((html) => {
          const items = $$('.product-grid__item', parse(html)).slice(0, limit);
          if (items.length >= Math.min(4, limit)) { grid.replaceChildren(...items.map((n) => document.importNode(n, true))); grid.classList.add('is-live'); }
        })
        .catch(() => {});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLiveSort); else initLiveSort();

  /* ---------- announcement rotator ---------- */
  class AnnouncementRotator extends HTMLElement {
    connectedCallback() {
      this.msgs = $$('.announcement__msg', this);
      if (this.msgs.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const ms = (parseInt(this.dataset.interval, 10) || 5) * 1000;
      let i = Math.max(0, this.msgs.findIndex((m) => m.classList.contains('is-active')));
      const tick = () => { this.msgs[i].classList.remove('is-active'); i = (i + 1) % this.msgs.length; this.msgs[i].classList.add('is-active'); };
      this.timer = setInterval(tick, ms);
      this.addEventListener('mouseenter', () => clearInterval(this.timer));
      this.addEventListener('focusin', () => clearInterval(this.timer));
      this.addEventListener('mouseleave', () => { clearInterval(this.timer); this.timer = setInterval(tick, ms); });
    }
    disconnectedCallback() { clearInterval(this.timer); }
  }
  customElements.define('announcement-rotator', AnnouncementRotator);

  /* ---------- predictive search ---------- */
  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enabled !== 'true') return;
      this.input = $('input[type=search]', this);
      this.results = $('[data-results]', this);
      this.controller = null;
      this.input.addEventListener('input', debounce(() => this.search(), 250));
      this.input.addEventListener('keydown', (e) => this.nav(e));
    }
    async search() {
      const q = this.input.value.trim();
      if (q.length < 2) { this.results.innerHTML = ''; this.input.setAttribute('aria-expanded', 'false'); return; }
      this.controller?.abort(); this.controller = new AbortController();
      try {
        const url = `${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection,page,article,query&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search`;
        const res = await fetch(url, { signal: this.controller.signal });
        if (!res.ok) throw new Error(res.status);
        const doc = parse(await res.text());
        const inner = doc.querySelector('#shopify-section-predictive-search') || doc.body;
        this.results.innerHTML = inner.innerHTML;
        this.input.setAttribute('aria-expanded', 'true');
      } catch (err) { if (err.name !== 'AbortError') this.results.innerHTML = ''; }
    }
    nav(e) {
      if (!['ArrowDown', 'ArrowUp'].includes(e.key)) return;
      const items = $$('a', this.results); if (!items.length) return;
      e.preventDefault();
      let i = items.findIndex((a) => a.getAttribute('aria-selected') === 'true');
      items.forEach((a) => a.removeAttribute('aria-selected'));
      i = e.key === 'ArrowDown' ? (i + 1) % items.length : (i <= 0 ? items.length - 1 : i - 1);
      items[i].setAttribute('aria-selected', 'true'); items[i].focus();
    }
  }
  customElements.define('predictive-search', PredictiveSearch);

  /* ---------- cart ---------- */
  const drawerEl = () => document.getElementById('CartDrawer');
  function cartSections() {
    const ids = [];
    if (drawerEl()) ids.push('cart-drawer');
    const page = $('[data-cart-page]');
    const sec = page?.closest('.shopify-section');
    if (sec) ids.push(sec.id.replace('shopify-section-', ''));
    return ids;
  }
  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.classList.toggle('is-empty', !count); });
    $$('[data-cart-count-label]').forEach((el) => { el.textContent = el.textContent.replace(/\d+/, count); });
  }
  function renderCartSections(sections) {
    if (!sections) return;
    Object.entries(sections).forEach(([id, html]) => {
      if (!html) return;
      const doc = parse(html);
      if (id === 'cart-drawer') {
        const fresh = doc.querySelector('[data-cart-drawer-inner]');
        const cur = $('[data-cart-drawer-inner]', drawerEl());
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      } else {
        const fresh = doc.querySelector('[data-cart-page]');
        const cur = $('[data-cart-page]');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      }
    });
  }
  async function refreshCount() {
    try { const c = await (await fetch(`${T.routes.cart}.js`)).json(); updateCount(c.item_count); return c; } catch (e) { return null; }
  }
  function openCart(opener) {
    const d = drawerEl();
    if (d && T.cartType === 'drawer') { if (!isOpen(d)) openOverlay(d, opener || $('[data-cart-open]')); return true; }
    return false;
  }
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-cart-open]');
    if (link && openCart(link)) e.preventDefault();
  });

  async function changeLine(line, quantity, root) {
    const row = $(`[data-line="${line}"]`, root);
    row?.classList.add('is-loading');
    try {
      const res = await fetch(`${T.routes.cartChange}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity), sections: cartSections(), sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) { toast(data.description || data.message || T.strings.error); row?.classList.remove('is-loading'); return; }
      renderCartSections(data.sections);
      updateCount(data.item_count);
    } catch (err) { toast(T.strings.error); row?.classList.remove('is-loading'); }
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    e.preventDefault();
    changeLine(btn.dataset.lineChange, btn.dataset.qty, btn.closest('cart-drawer, [data-cart-page]') || document);
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-input]');
    if (input) { changeLine(input.dataset.lineInput, Math.max(0, parseInt(input.value, 10) || 0), input.closest('cart-drawer, [data-cart-page]') || document); return; }
    const note = e.target.closest('[data-cart-note]');
    if (note) fetch(`${T.routes.cartUpdate}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
  });

  class CartDrawer extends HTMLElement {}
  customElements.define('cart-drawer', CartDrawer);

  /* ---------- product forms (PDP, quick add, card add) ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) {
      const confirmForm = e.target.closest('form[data-confirm]');
      if (confirmForm && !window.confirm(confirmForm.dataset.confirm)) e.preventDefault();
      return;
    }
    e.preventDefault();
    const btn = $('[data-add-button], [type=submit]', form);
    const err = $('[data-form-error]', form);
    if (btn?.disabled) return;
    btn?.classList.add('is-loading'); btn?.setAttribute('aria-disabled', 'true');
    if (err) err.hidden = true;
    const body = new FormData(form);
    const secs = cartSections();
    if (secs.length) { body.append('sections', secs.join(',')); body.append('sections_url', window.location.pathname); }
    try {
      const res = await fetch(`${T.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body });
      const data = await res.json();
      if (!res.ok || data.status) {
        const msg = data.description || data.message || T.strings.error;
        if (err) { err.textContent = msg; err.hidden = false; } else toast(msg);
        return;
      }
      const modal = $('#QuickAddModal'); if (modal && isOpen(modal)) closeOverlay(modal);
      if (T.cartType === 'page' && !drawerEl()) { window.location.href = T.routes.cart; return; }
      renderCartSections(data.sections);
      await refreshCount();
      if (!openCart()) toast(T.strings.added);
    } catch (ex) {
      if (err) { err.textContent = T.strings.error; err.hidden = false; } else toast(T.strings.error);
    } finally {
      btn?.classList.remove('is-loading'); btn?.removeAttribute('aria-disabled');
    }
  });

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-qty-step]');
    if (!step) return;
    const input = $('input', step.closest('[data-quantity]'));
    const min = parseInt(input.min || '1', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || min) + parseInt(step.dataset.qtyStep, 10));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- quick add ---------- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const modal = $('#QuickAddModal');
    const content = $('[data-quick-add-content]', modal);
    btn.classList.add('is-loading');
    try {
      const url = btn.dataset.quickAdd;
      const res = await fetch(`${url}${url.includes('?') ? '&' : '?'}section_id=quick-add`);
      const doc = parse(await res.text());
      const inner = doc.querySelector('.quick-add');
      if (!inner) { window.location.href = url; return; }
      content.innerHTML = '';
      content.appendChild(document.importNode(inner, true));
      // re-run inline JSON-dependent elements: custom elements upgrade automatically on insert
      openOverlay(modal, btn);
      if (window.Shopify?.PaymentButton) window.Shopify.PaymentButton.init();
    } catch (ex) { window.location.href = btn.dataset.quickAdd; }
    finally { btn.classList.remove('is-loading'); }
  });

  /* ---------- variant picker ---------- */
  class VariantPicker extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse($('[data-variants]', this)?.textContent || '[]');
      this.root = this.closest('[data-product-section]') || document;
      this.addEventListener('change', (e) => this.onChange(e));
    }
    selected() {
      const vals = [];
      $$('[data-option-index]', this).forEach((el) => {
        const i = Number(el.dataset.optionIndex);
        if (el.tagName === 'SELECT') vals[i] = el.value;
        else if (el.checked) vals[i] = el.value;
      });
      return vals;
    }
    onChange(e) {
      const fs = e.target.closest('fieldset');
      const label = fs && $('[data-selected-value]', fs);
      if (label) label.textContent = e.target.value;
      const vals = this.selected();
      const v = this.variants.find((x) => x.options.every((o, i) => o === vals[i]));
      const forms = $$('form[data-product-form]', this.root);
      const addBtns = $$('[data-add-button]', this.root);
      if (!v) {
        addBtns.forEach((b) => { b.disabled = true; const l = $('[data-add-label]', b); if (l) l.textContent = T.strings.unavailable; });
        return;
      }
      forms.forEach((f) => { const id = $('[data-variant-id]', f) || $('input[name=id]', f); if (id) { id.value = v.id; id.dispatchEvent(new Event('change', { bubbles: true })); } });
      addBtns.forEach((b) => { b.disabled = !v.available; const l = $('[data-add-label]', b); if (l) l.textContent = v.available ? T.strings.addToCart : T.strings.soldOut; });
      const sku = $('[data-sku]', this.root);
      if (sku) { sku.hidden = !v.sku; const s = $('span', sku); if (s) s.textContent = v.sku || ''; }
      if (v.featured_media_id) document.dispatchEvent(new CustomEvent('variant:media', { detail: { mediaId: v.featured_media_id, root: this.root } }));
      const isQuick = this.dataset.section === 'quick-add';
      if (!isQuick) {
        const u = new URL(window.location.href); u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
      this.refetch(v.id);
    }
    async refetch(variantId) {
      this.controller?.abort(); this.controller = new AbortController();
      try {
        const res = await fetch(`${this.dataset.url}?variant=${variantId}&section_id=${this.dataset.section}`, { signal: this.controller.signal });
        const doc = parse(await res.text());
        ['[data-price-wrap]', '[data-pickup]', '[data-inventory]', '[data-sku]'].forEach((sel) => {
          const fresh = doc.querySelector(sel), cur = $(sel, this.root);
          if (fresh && cur) { cur.innerHTML = fresh.innerHTML; cur.hidden = fresh.hidden; }
        });
        $$('.pill', this).forEach((pill) => {
          const fresh = doc.querySelector(`label[for="${pill.getAttribute('for')}"]`);
          if (fresh) pill.classList.toggle('is-unavailable', fresh.classList.contains('is-unavailable'));
        });
      } catch (e) { /* aborted */ }
    }
  }
  customElements.define('variant-picker', VariantPicker);

  /* ---------- media gallery ---------- */
  class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-gallery-track]', this);
      this.thumbs = $$('[data-thumb]', this);
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.go(t.dataset.thumb)));
      document.addEventListener('variant:media', (e) => { if (e.detail.root.contains(this)) this.go(e.detail.mediaId); });
      if (this.track && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting && en.intersectionRatio > .6) this.mark(en.target.dataset.mediaId); }), { root: this.track, threshold: [.6] });
        $$('[data-media-id]', this.track).forEach((it) => io.observe(it));
      }
    }
    go(id) {
      const item = $(`[data-media-id="${id}"]`, this.track);
      if (!item) return;
      this.track.scrollTo({ left: item.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      this.mark(id);
    }
    mark(id) { this.thumbs.forEach((t) => { const on = String(t.dataset.thumb) === String(id); t.classList.toggle('is-active', on); t.setAttribute('aria-current', on ? 'true' : 'false'); }); }
  }
  customElements.define('media-gallery', MediaGallery);

  /* ---------- product tabs ---------- */
  class ProductTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = $$('[role=tab]', this);
      this.tabs.forEach((t, i) => {
        t.addEventListener('click', () => this.select(i));
        t.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); const n = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length; this.select(n); this.tabs[n].focus(); }
        });
      });
    }
    select(i) {
      this.tabs.forEach((t, j) => {
        const on = i === j;
        t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1;
        const p = document.getElementById(t.getAttribute('aria-controls')); if (p) p.hidden = !on;
      });
    }
  }
  customElements.define('product-tabs', ProductTabs);

  /* ---------- product recommendations ---------- */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const load = async () => {
        try {
          const doc = parse(await (await fetch(this.dataset.url)).text());
          const fresh = doc.querySelector('product-recommendations');
          if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
        } catch (e) { /* ignore */ }
      };
      if (!('IntersectionObserver' in window)) return load();
      const io = new IntersectionObserver((en) => { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  /* ---------- facet filters (Search & Discovery) ---------- */
  class FacetFilters extends HTMLElement {
    connectedCallback() {
      this.form = $('[data-facets-form]', this);
      if (!this.form) return;
      const run = debounce(() => this.apply(this.queryFromForm()), 400);
      this.form.addEventListener('change', (e) => { if (e.target.matches('[data-facet-input], .facet__check, input[type=number]')) run(); });
      this.form.addEventListener('submit', (e) => { e.preventDefault(); this.apply(this.queryFromForm()); });
      this.addEventListener('click', (e) => {
        const a = e.target.closest('[data-facet-link]');
        if (!a) return;
        e.preventDefault();
        const u = new URL(a.href, window.location.origin);
        this.apply(u.searchParams.toString(), u.pathname);
      });
    }
    queryFromForm() {
      const fd = new FormData(this.form);
      const p = new URLSearchParams();
      for (const [k, v] of fd.entries()) { if (v !== '') p.append(k, v); }
      const q = new URLSearchParams(window.location.search).get('q');
      if (q && !p.has('q')) p.set('q', q);
      return p.toString();
    }
    async apply(query, path = window.location.pathname) {
      const sectionId = this.dataset.section;
      const container = this.closest('[data-results]') || $('#ResultsContainer');
      const drawer = $('#FacetsDrawer', this);
      const wasOpen = drawer && isOpen(drawer);
      if (wasOpen) { const e = openStack.find((o) => o.el === drawer); const i = openStack.indexOf(e); if (i > -1) openStack.splice(i, 1); }
      container?.classList.add('is-loading');
      try {
        const sep = query ? '&' : '';
        const res = await fetch(`${path}?${query}${sep}section_id=${sectionId}`);
        const doc = parse(await res.text());
        const fresh = doc.querySelector('#ResultsContainer') || doc.querySelector('[data-results]');
        if (fresh && container) container.innerHTML = fresh.innerHTML;
        window.history.replaceState({}, '', `${path}${query ? '?' + query : ''}`);
        if (wasOpen) {
          const nd = $('#FacetsDrawer');
          const opener = $('[data-drawer-open="FacetsDrawer"]');
          if (nd) openOverlay(nd, opener);
        } else { document.body.classList.remove('is-locked'); }
      } catch (e) { window.location.href = `${path}?${query}`; }
      finally { container?.classList.remove('is-loading'); }
    }
  }
  customElements.define('facet-filters', FacetFilters);

  /* ---------- share ---------- */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-share]');
    if (!b) return;
    const url = b.dataset.share, title = b.dataset.shareTitle || document.title;
    if (navigator.share) { try { await navigator.share({ title, url }); } catch (x) { /* cancelled */ } }
    else if (navigator.clipboard) { await navigator.clipboard.writeText(url); toast('Link copied'); }
  });

  /* ---------- theme editor support ---------- */
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('cart-drawer')) refreshCount();
  });
  document.addEventListener('shopify:block:select', (e) => {
    const msg = e.target.closest('announcement-rotator') && e.target;
    if (msg && msg.classList.contains('announcement__msg')) { $$('.announcement__msg', msg.parentElement).forEach((m) => m.classList.toggle('is-active', m === msg)); }
    const tab = e.target.matches('[role=tab]') && e.target;
    if (tab) tab.click();
  });

  window.theme = Object.assign(T, { toast, openCart, refreshCount });
})();

/* ---------- Organic layer: live store hours + scroll reveal (vanilla, no libraries) ---------- */
(() => {
  'use strict';
  const DAYS = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
  const DAY_NAMES = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  const TZ = 'America/Vancouver';

  // "Mo-Sa 10:00-20:00, Su 12:00-20:00" -> [[open,close] minutes] per weekday (0 = Monday)
  const parseHours = (str) => {
    const week = DAYS.map(() => []);
    String(str || '').split(/(?<=\d)\s*[,;]\s*/).forEach((seg) => {
      const m = seg.trim().match(/^([A-Za-z,\- ]+?)\s+(\d{1,2}):(\d{2})\s*-\s*(\d{1,2}):(\d{2})$/);
      if (!m) return;
      const open = +m[2] * 60 + +m[3];
      let close = +m[4] * 60 + +m[5];
      if (close <= open) close += 1440;
      m[1].split(',').forEach((part) => {
        const [a, b] = part.trim().split('-').map((d) => DAYS.indexOf(d.trim()));
        if (a < 0) return;
        const end = b >= 0 ? b : a;
        for (let i = a; ; i = (i + 1) % 7) { week[i].push([open, close]); if (i === end) break; }
      });
    });
    return week;
  };

  const nowInStoreZone = () => {
    const parts = new Intl.DateTimeFormat('en-US', { timeZone: TZ, weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
    const get = (t) => (parts.find((p) => p.type === t) || {}).value;
    const day = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(get('weekday'));
    return { day, minutes: (+get('hour') % 24) * 60 + +get('minute') };
  };

  const fmt = (min) => {
    min %= 1440;
    const h = Math.floor(min / 60), m = min % 60;
    const h12 = h % 12 || 12;
    return h12 + (m ? ':' + String(m).padStart(2, '0') : '') + (h < 12 ? ' AM' : ' PM');
  };

  const statusFor = (week) => {
    const { day, minutes } = nowInStoreZone();
    if (day < 0) return null;
    const prev = (day + 6) % 7;
    // still open from a past-midnight range yesterday
    for (const [o, c] of week[prev]) if (c > 1440 && minutes < c - 1440) return { open: true, close: c - 1440, left: c - 1440 - minutes };
    for (const [o, c] of week[day]) if (minutes >= o && minutes < c) return { open: true, close: c, left: c - minutes };
    const later = week[day].filter(([o]) => o > minutes).sort((x, y) => x[0] - y[0])[0];
    if (later) return { open: false, opens: later[0], dayOffset: 0 };
    for (let i = 1; i <= 7; i++) {
      const d = (day + i) % 7;
      const first = week[d].slice().sort((x, y) => x[0] - y[0])[0];
      if (first) return { open: false, opens: first[0], dayOffset: i, dayIndex: d };
    }
    return { open: false };
  };

  const renderStatus = (el) => {
    const week = el._week || (el._week = parseHours(el.dataset.hours));
    const st = statusFor(week);
    if (!st) return;
    const L = el.dataset;
    const state = el.querySelector('[data-store-state]');
    const detail = el.querySelector('[data-store-detail]');
    el.classList.toggle('is-open', st.open);
    el.classList.toggle('is-closed', !st.open);
    el.classList.toggle('is-soon', !!(st.open && st.left <= 60));
    if (st.open) {
      state.textContent = L.lOpen;
      detail.textContent = (st.left <= 60 ? L.lSoon : L.lCloses).replace('%T', fmt(st.close));
    } else {
      state.textContent = L.lClosed;
      if (st.opens == null) detail.textContent = '';
      else if (st.dayOffset === 0) detail.textContent = L.lOpens.replace('%T', fmt(st.opens));
      else detail.textContent = L.lOpensDay.replace('%D', st.dayOffset === 1 ? 'tomorrow' : DAY_NAMES[st.dayIndex]).replace('%T', fmt(st.opens));
    }
    el.hidden = false;
  };

  const initStatus = (root = document) => {
    root.querySelectorAll('[data-store-status]').forEach(renderStatus);
    const today = nowInStoreZone().day;
    root.querySelectorAll('[data-hours-table] tr[data-day]').forEach((tr) => tr.classList.toggle('is-today', +tr.dataset.day === today));
  };

  // Scroll reveal: only when the merchant enabled motion and the visitor has not asked for reduced motion.
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const REVEAL = '.section__head, .hero__box, .trust__item, .tile, .product-grid__item, .store-card:not(.store-card--compact), .rich-text__inner, .rte-block, .image-with-text__media, .image-with-text__content, .organic-reveal';
  let io;
  const initReveal = (root = document) => {
    if (!document.body.classList.contains('has-motion') || reduce.matches || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('reveal-on');
    io = io || new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting || e.boundingClientRect.bottom < 0) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    root.querySelectorAll(REVEAL).forEach((el) => {
      if (el.classList.contains('reveal') || el.closest('.drawer, .modal, .cart-drawer, .predictive-search, .product-grid--scroll .product-grid__item:nth-child(n+5)')) return;
      const sibs = el.parentElement ? Array.from(el.parentElement.children).filter((c) => c.matches(REVEAL)) : [];
      el.style.setProperty('--reveal-i', Math.min(Math.max(sibs.indexOf(el), 0), 6));
      el.classList.add('reveal');
      io.observe(el);
    });
  };
  reduce.addEventListener && reduce.addEventListener('change', () => {
    if (reduce.matches) document.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-in'));
  });

  const boot = () => {
    initStatus();
    initReveal();
    setInterval(initStatus, 60000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => { initStatus(e.target); initReveal(e.target); e.target.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-in')); });
})();
